export default __webpack_public_path__ + "static/media/icon3.ca6a7d0b.svg";